<div class="input-group">
  @if (showDaterange) {
    <app-material-date-range
      class="me-2"
      id="selectedDateRange"
      [(dateRange)]="dateRange"
      (dateRangeChange)="date($event)"
      >
    </app-material-date-range>
  }

  <app-material-auto-complete
    [formatter]="truckListFormatter"
    [placeholder]="'Truck'"
    [(ngModel)]="_selectedTruck"
    (ngModelChange)="selectTruck($event)"
    name="truck"
    [items]="filteredTrucks">
  </app-material-auto-complete>

  @if (!showReportLink) {
  <app-material-organisation-selector
    class="ms-1"
    id="Organisation"
    name="selectedOrganisation"
    [(ngModel)]="_selectedOrganisationId"
    (ngModelChange)="selectOrganisation($event)"
    [placeholder]="'Organisation'"
    [organisationLanguage]="'fa'"
    [organisations]="organisations">
  </app-material-organisation-selector>
    }

  <button
    mat-stroked-button
    class=" ms-1"
    (click)="showAll()">
    Show All
  </button>

  <button
    class="ms-1"
    mat-stroked-button
    data-bs-toggle="dropdown">
    Action
  </button>

  <ul class="dropdown-menu mat-elevation-z4 p-2">
    <li>
      <a class="dropdown-item dropdown-item d-flex align-items-center"
        (click)="zoomOutMap()">
        Zoom Out
      </a>
    </li>

    <li>
      <a class="dropdown-item"
        (click)="showOutOfReach()"
        style="color: orange"
        title="off trucks">
        <i class="fas fa-truck-pickup"></i>
        {{ _numberOfUnavailableTrucks }}
      </a>
    </li>

    <li>
      <a class="dropdown-item"
        (click)="showAvailables()"
        style="color: green"
        title="on trucks">
        <i class="fas fa-truck"></i>
        {{ _numberOfAvailableTrucks }}
      </a>
    </li>
  </ul>

</div>